var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("form-element-viewer " + _vm.type + "-viewer")},[_c((_vm.type === 'prioritize') ? 'ol' : 'ul',{tag:"component"},_vm._l((_vm.value),function(entry,key){return _c('li',{key:key},[_vm._v(" "+_vm._s(entry)+" ")])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }